// 1优秀100分，2良好75分，3一般50分，4差25分
const scoreLevelMap: Record<number, number> = {
  100: 1,
  75: 2,
  50: 3,
  25: 4,
};

export function getScoreLevelByScore(score: number | null) {
  if (!score) return null;

  return scoreLevelMap[score];
}
